import { render, staticRenderFns } from "./sushi-boat-service.vue?vue&type=template&id=64827251&"
import script from "./sushi-boat-service.vue?vue&type=script&lang=js&"
export * from "./sushi-boat-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports